import styled from "styled-components";
import { FC } from "react";
import { BaseComponentProps } from "../types";

export enum BreadcrumbsTestIds {
  Container = "breadcrumbs",
}

const StyledOl = styled.ol`
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
`;

type BreadcrumbsProps = BaseComponentProps<"nav"> & {
  className?: string;
  id?: string;
  testId?: string;
};

export const Breadcrumbs: FC<BreadcrumbsProps> = ({
  children,
  className,
  id,
  testId,
}) => {
  return (
    <nav
      className={className}
      data-testid={testId ?? BreadcrumbsTestIds.Container}
      id={id}
    >
      <StyledOl>{children}</StyledOl>
    </nav>
  );
};
